/** @format */

import React, { useRef, useState } from 'react';
import {
  PageContainer,
  TableComponents,
  FilterPod,
  LoadingPage,
  SimpleDialog,
  Icons,
} from 'components';
import { useStyles } from './style';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { useBusiness } from 'hooks';
import Services from '../services';
import { columns, generateData } from './components/columns';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

const Bills = () => {
  //* * States */
  const {
    filters,
    setFilters,
    openDialog,
    setOpenDialog,
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    page,
    setPage,
  } = useCustomHook();

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  //* * Hooks */
  const tableRef = useRef();
  const businessInfo = useBusiness();
  const classes = useStyles();
  const navigate = useNavigate();
  const actionsList = getDynamicObjectAction([
    'contentAuthPage',
    'newRequestAuthBtn',
    'contentBusinessPage',
  ]);
  //* * API */
  const getData = async (query) => {
    try {
      setLoading(true);

      const orderBy = [];

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await Services.getRequests(params);

      let list = [];

      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  //* * Other Functions */
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const hint =
    'در این بخش شما می‌توانید لیست درخواست‌های خود را مشاهده و در صورت لزوم درخواست جدیدی را ایجاد نمایید.';

  return (
    <PageContainer
      title="احراز هویت کسب‌وکار"
      pageKey="requestConfirmation"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.REQUEST_CONFIRMATION_AUTH}
      className={classes.root}
    >
      {!businessInfo?.id ? (
        <LoadingPage />
      ) : !businessInfo?.parentBusiness ? (
        <>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="flex-end"
              style={{ marginBottom: 16 }}
            >
              {actionsList['contentAuthPage'] && (
                <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
              )}
              {(actionsList['newRequestAuthBtn'] || actionsList['contentBusinessPage']) && (
                <Button
                  onClick={() => {
                    if (businessInfo.active) {
                      setOpenDialog(true);
                    } else {
                      navigate('/NewRequestConfirmation');
                    }
                  }}
                  color="primary"
                  startIcon={<Icons icon="plusCircle" color="#fff" size="18" />}
                  variant="contained"
                >
                  ارسال درخواست جدید
                </Button>
              )}
            </Box>

            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>

          {actionsList['contentAuthPage'] && (
            <Grid item xs={12} className={classes.tableContainer}>
              <TableComponents
                data={getData}
                columns={columns()}
                isLoading={loading}
                ref={tableRef}
                onChange={(ps) => {
                  setPage(ps?.pageNumber);
                  setSize(ps?.pageSize);
                  return getData(ps);
                }}
              />
            </Grid>
          )}
        </>
      ) : (
        <Typography align="center" className={classes.notAvailabelBranch}>
          دسترسی به این بخش برای شعبه های کسب‌وکار، ممکن نیست!
        </Typography>
      )}
      <SimpleDialog
        title="ارسال درخواست جدید"
        open={openDialog}
        onClose={handleCloseDialog}
        actions={
          <Button color="primary" variant="contained" onClick={handleCloseDialog}>
            بستن
          </Button>
        }
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography align="left">کسب و کار شما قبلا تایید شده است!</Typography>
          </Grid>
        </Grid>
      </SimpleDialog>
    </PageContainer>
  );
};

export default Bills;
